import ImageCustom from '@site/components/molecules/ImageCustom'
import styled from 'styled-components'

export const StyledImageCustom = styled( ImageCustom )`
  width: 280px;
  height: 182px;
  background-color: #fff;
  border-radius: 28px;
  object-fit: contain;
  cursor: pointer;
  box-shadow: 0px 2px 2px 0px rgba(0,0,0,0.18);

  img {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain !important;
  }

  @media (min-width: ${props => props.theme.mediaQuery.smallpc}) {
    width: 400px;
    height: 259px;
  }
`

export const ImageWrapper = styled.div`
  padding-left: 8px;
  padding-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`
